export const tokens = {
  color: {
    canvas: '#f4f7f4',
    surface: '#fcfefc',
    subtle: '#e9efeb',
    accent: '#315f4f',
    accentStrong: '#1f4438',
    accentGradient: '#467565',
    accentSoft: '#dfece6',
    eucalyptus: '#5b786c',
    eucalyptusGradient: '#6f8f81',
    eucalyptusSoft: '#e3ece8',
    text: '#26332e',
    textMuted: '#66736d',
    border: '#d5dfda',
    borderStrong: '#b5c5bd',
    success: '#2f6b52',
    successSoft: '#deeee6',
    warning: '#6f4216',
    warningSoft: '#f7ead5',
    danger: '#924b4e',
    dangerSoft: '#f7e4e3',
    info: '#526684',
    infoSoft: '#e5eaf2',
    white: '#ffffff',
    doctorAvatar: '#376454',
    secretaryAvatar: '#5b7469',
  },
  overlay: {
    canvasGlass: 'rgba(244, 247, 244, 0.93)',
    whiteStrong: 'rgba(255, 255, 255, 0.16)',
    whiteMedium: 'rgba(255, 255, 255, 0.12)',
  },
  radius: {
    small: 10,
    control: 12,
    panel: 18,
    large: 24,
  },
  shadow: {
    floating: '0 18px 50px rgba(35, 69, 57, 0.12)',
    interactive: '0 8px 24px rgba(35, 69, 57, 0.09)',
    message: '0 4px 12px rgba(35, 60, 51, 0.05)',
    signInRings: '0 0 0 70px rgba(255, 255, 255, 0.035), 0 0 0 140px rgba(255, 255, 255, 0.025)',
  },
  sidebarWidth: 248,
} as const;
